import { MoreVert } from '@mui/icons-material';
import { Alert, Button, IconButton, Switch, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { Challenge } from '../../../interfaces/interfaces';
import { fetchAndSetChallenges } from '../../../reduxToolkit/slices/commonSlice';
import { useDispatch, useSelector } from '../../../reduxToolkit/typedRedux';
import { deleteChallenge, updateChallenge } from '../../../services/services';
import { VyConfirm } from '../../common/VyConfirm';
import VyModal from '../../common/VyModal';
import VyPopoverMenu from '../../common/VyPopoverMenu';
import ChallengeModal from './ChallengeModal';
import ParticipantsModal from './participantsModal';

interface ChallengeSettingsFormInterface {
  open?: boolean;
  onClose?: () => void;
}

const ChallengeSettingsForm = ({ open, onClose }: ChallengeSettingsFormInterface) => {
  const [currentChallenge, setCurrentChallenge] = useState<Challenge | undefined>();
  const [currentSubmissions, setCurrentSubmissions] = useState<any[]>([]);

  const event = useSelector((state) => state.common.event);
  const challenges = useSelector((state) => state.common.challenges);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  async function _updateChallenge(challengeid: string, props: any) {
    if (!event) return;
    const { name, description, isActive, isSequential = false, tasks } = props;
    try {
      await updateChallenge(challengeid, { name, description, isActive, isSequential, tasks });
      toast.success(t('toasts:change-success'));
      dispatch(fetchAndSetChallenges(event?._id));
    } catch (err) {
      console.error(err);
    }
  }

  async function _deleteChallenge(challengeId: string) {
    if (!event) return;

    try {
      await deleteChallenge(challengeId);
      dispatch(fetchAndSetChallenges(event._id));
    } catch (err) {
      console.error(err);
    }
  }
  if (challenges.length < 1) {
    return (
      <Alert severity="info" className="m-4">
        {t('account:challenges.no-challenges-exist')}
      </Alert>
    );
  }

  return (
    <div className="flex flex-col">
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">{t('account:challenges.name')}</TableCell>
            <TableCell align="right">{t('account:challenges.is-active')}</TableCell>
            <TableCell align="right">{t('account:challenges.participantcount')}</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {challenges?.map((challenge) => (
            <TableRow key={challenge._id}>
              <TableCell width="100%" onClick={() => setCurrentChallenge(challenge)} align="left">
                {challenge.name}
              </TableCell>
              <TableCell align="right">
                <Switch
                  name="isActive"
                  onChange={async (e) => {
                    _updateChallenge(challenge._id, {
                      ...challenge,
                      isActive: e.target.checked,
                    });
                  }}
                  checked={challenge.isActive}
                />
              </TableCell>
              <TableCell align="center">{challenge?.submissions?.length ?? 0}</TableCell>
              <TableCell>
                <VyPopoverMenu
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  content={() => (
                    <div>
                      <Button onClick={() => setCurrentChallenge(challenge)}>{t('common:edit')}</Button>
                      <Button
                        onClick={() => setCurrentSubmissions(challenge?.submissions)}
                        disabled={!challenge?.submissions || challenge?.submissions?.length < 1}>
                        {t('account:challenges.participants')}
                      </Button>
                      <VyConfirm onConfirm={async () => _deleteChallenge(challenge._id)}>
                        <Button>{t('common:delete')}</Button>
                      </VyConfirm>
                    </div>
                  )}>
                  <IconButton>
                    <MoreVert />
                  </IconButton>
                </VyPopoverMenu>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <VyModal
        maxWidth="90vw"
        title={t('account:challenges.participants') + ' (' + currentSubmissions?.length + ')'}
        open={currentSubmissions?.length > 0}
        disableDefaultStyling
        onClose={() => setCurrentSubmissions([])}>
        {() => (
          <div>
            <ParticipantsModal submissions={currentSubmissions} challenge={currentSubmissions[0].challenge} />
          </div>
        )}
      </VyModal>
      {currentChallenge && (
        <ChallengeModal
          open={!!currentChallenge}
          currentChallenge={currentChallenge}
          onClose={() => {
            setCurrentChallenge(undefined);
          }}
        />
      )}
    </div>
  );
};
export default ChallengeSettingsForm;
